module.exports = __webpack_public_path__ + "static/media/blog-single.8f6fc4ac.jpg";